
import { ButtonBarItem, ButtonBarOptions } from "@/types/controls";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BigButtonBar from "./BigButtonBar.vue";
import ButtonBar from "./ButtonBar.vue";

@Component({
  components: {
    BigButtonBar,
    ButtonBar
  }
})
export default class ButtonBarInput extends Vue {
  @Prop()
  value!: string | null;

  @Prop()
  placeholder?: string;

  @Prop({
    default() {
      return [];
    }
  })
  items!: ButtonBarItem[];

  @Prop()
  options?: ButtonBarOptions;

  get internalValue() {
    return this.value;
  }

  set internalValue(string: string | null) {
    this.$emit("input", string);
  }
}
